let fullFillPromise: any = null;

export function createScript(scriptURL: string): Promise<null> {
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    scriptTag.src = scriptURL;
    scriptTag.onload = () => {
        fullFillPromise()
    };
    const s = document.getElementsByTagName('body')[0];
    s.appendChild(scriptTag);

    return new Promise((scriptLoaded) => {
        fullFillPromise = scriptLoaded
    });
}

export function iframeCheck(): boolean {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export function throttle(func: () => any, wait: number): () => void {
    let previous: number, timeout: number;
    timeout = 0;
    previous = 0;
    const later = function (): void {
        previous = new Date().getTime();
        window.clearTimeout(timeout);
        timeout = 0;
        func();
    };

    return function (): any {
        const now = new Date().getTime();
        const remaining = wait - (now - previous);
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = 0;
            previous = now;
            return func();
        } else if (!timeout) {
            timeout = window.setTimeout(later, remaining);
        }
    };
}


export function typeToHR(type: number): string {
    const typeToHR: any = {
        1: 'TEXT',
        3: 'ATTACHMENT',
        40: 'QUESTION',
        41: 'ANSWER',
        35: 'TYPING',
        38: 'PAY',
        45: 'MEDIA',
        46: 'EMBED_CODE',
        200: 'PAY_BUTTON',
        210: 'CMD_CHANGE_BACKGROUND',
        211: 'CMD_SET_INPUT_UI_STICKY',
        212: 'CMD_SET_GLOBAL_CFG_ITEM',
        400: 'HUMAN_TAKEOVER'
    };
    return typeToHR[type.toString()];
}

/*
    scriptTag.onreadystatechange = function () {
        if (this.readyState == 'complete') {
            callback();
        }
    };
*/
